/**
 * The registration of a Mexican SAPI that counts a foreign partner (LIE art. 32): how late it is, and
 * whether the form that records it is complete. The server decides the rest (the date cannot be ahead,
 * the company must be one the portal counts partners for).
 */
import type { RegistrationOwed } from '../services/rnieRegistrations.service';

const FOLIO_MIN = 3;

export type OwedState = 'overdue' | 'due_today' | 'open';

export function owedState(item: Pick<RegistrationOwed, 'business_days_left'>): OwedState {
  if (item.business_days_left < 0) return 'overdue';
  return item.business_days_left === 0 ? 'due_today' : 'open';
}

export function canRecord(input: { filedOn: string; folio: string }): boolean {
  return input.filedOn !== '' && input.folio.trim().length >= FOLIO_MIN;
}

/** The sentence that says how many partners make the registration owed. */
export function partnersLine(count: number): string {
  return count === 1 ? 'One foreign partner is counted.' : `${count} foreign partners are counted.`;
}
